'use client'

import React, { useState } from 'react'
import styles from './HeaderClientWrapper.module.scss'
import LoginModal from '../LoginModal'

type HeaderClientWrapperProps = {
  children: React.ReactNode
}

const HeaderClientWrapper = ({ children }: HeaderClientWrapperProps) => {
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false)
  return (
    <header className={styles.headerWrapper}>
      {children}

      {/* Login Modal */}
      <LoginModal isLoginModalOpen={isLoginModalOpen} setIsLoginModalOpen={setIsLoginModalOpen} />
    </header>
  )
}

export default HeaderClientWrapper
